import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';
import DATA_MINING_CONTROLLER from '../../../controllers/dataMining';
import Logger, { LOG_LEVELS } from '../../../utils/log';
import ReactComponentHelper from '../../helper/ReactComponentHelper';
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import Pagination from '../../page/Pagination'
import IntrastatLines from "../reportDefinition/IntrastatLines.json";

const log = new Logger('DATA_MINING_INTRASTAT_LINES_PAGE', LOG_LEVELS.DEBUG);

const IntraLinesColumnMapping = {
    "id": "Nr", "documentNumber": "Document Number", "date": "Date", "reporterID": "Reporter ID", "reporterName": "Reporter Name"
    , "reportingCountry": "Reporting Country", "direction": "Direction", "transactionType": "Transaction Type", "countryDispatch": "Country Dispatch", "countryArrival": "Country Arrival"
    , "vatNumberSupplier": "VAT Number Supplier", "vatNumberCustomer": "VAT Number Customer", "fiscalNumber": "Fiscal Number",
    "producedByInvoiceLineID": "Produced By Invoice Line ID", "additionalTransactionType": "Additional Transaction Type",
    "statisticalProcedure": "Statistical Procedure", "partnerCurrency": "Partner Currency", "commodityCode": "Commodity Code", "serviceCode": "Service Code"
    , "quantity1": "Quantity1", "unit1": "Unit1", "quantity2": "Quantity2", "unit2": "Unit2", "commercialValue": "Commercial Value"
    , "statisticalValue": "Statistical Value", "additionalDescription": "Additional Description", "regionDispatch": "Region Dispatch", "harbourDispatch": "Harbour Dispatch"
    , "regionArrival": "Region Arrival", "harbourArrival": "Harbour Arrival", "modeOfTransport": "Mode Of Transport", "deliveryCondition": "Delivery Condition"
    , "countryOrigin": "Country Origin", "hireWorkValue": "Hire Work Value", "itemType": "Item Type", "nationalityTransportVehicle": "Nationality Transport Vehicle",
    "placeOfDelivery": "Place Of Delivery"
};

const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE,
    page:0,
    startAt: 1
};

export class IntrastatLinesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'Intrastat lines'
            },
            filterCriteria: props.filterCriteria,
            pagination: DEFAULT_PAGINATION_CONFIG,
            loading: true
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
    }


    getParameters(selection, pagination) {
        let params = {
            startAt: pagination.startAt,
            pageSize: pagination.pageSize,
            dateType: selection.dateType,
            startDate: selection.startDate,
            endDate: selection.endDate,
            sortAscending: selection.sortAscending
        };
        return params;
    }


    getColumns() {
        var columnData = IntrastatLines;

        log.debug('render(): columnData', columnData);

        const columns = columnData.map((item, id) => {
            log.debug('render(): item', item, item.Accessor, item.Header);
            return {
                id: item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header} />,
                accessor: ((item.Accessor === 'Commercial Value') || (item.Accessor === 'Statistical Value')) ?
                    d => <FormattedCurrencyValue value={d[item.Accessor]}></FormattedCurrencyValue> : item.Accessor,
                style: item.textAlign !== undefined ? { textAlign: "right" } : "",
                maxWidth: item.MaxWidth !== undefined ? item.MaxWidth : 1000,
            }
        })
        log.debug('render(): ', columns);
        return columns;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,
            page: page,
            pageSize: pageSize,
            startAt: startAt + 1
        });
        //To set default/hidden properties of react table
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page = 0;
        }
        this.setState({
            pagination: pagination,
            viewTableState: state,
            loading: true
        });

        this.props.doGetIntrastatLinesData(this.getParameters(this.props.filterCriteria, pagination), () => {
            let pagination = Object.assign({}, this.state.pagination);           
            let intrastatLinesData = this.props.intrastatLinesData || [];
            let totalCount = (this.props.intrastatLinesData && this.props.intrastatLinesData.totalCount) || intrastatLinesData.length;
            pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
            this.setState({
                loading: false,
                pagination: pagination
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //when reportType is same and filters are updated/changed and clicked apply, need to call fetch data explicitely
        if (!nextProps.isReportTypeChanged && (nextProps.filterCriteria !== this.props.filterCriteria)) {
            this.props = nextProps;
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        }
    }

    render() {
        log.debug('render() - props: ', this.props);
        let pagination = this.state.pagination || Object.assign({}, DEFAULT_PAGINATION_CONFIG);        
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page =pagination.page;
        }
        const columns = this.getColumns();
        let intrastatLinesData = (this.props.intrastatLinesData && this.props.intrastatLinesData.data) || [];
        for (var key in IntraLinesColumnMapping) {
            intrastatLinesData = JSON.parse(JSON.stringify(intrastatLinesData).split('"' + key + '":').join('"' + IntraLinesColumnMapping[key] + '":'));
        }
        let columnData = IntrastatLines;
        let dateCols = columnData.filter((column) => column.IsDate).map(column => column.Accessor);
        let currencyCols = columnData.filter((column) => column.IsCurrency).map(column => column.Accessor);
        let dateAndCurrencyFormatedIntrastatLinesData = intrastatLinesData.map(dataRow => {
            dateCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? `${dataRow[accessor]}`.substr(0, 10) : dataRow[accessor];
                const formattedDate = (dataRow[accessor] === "1899-12-30" ? "" : dataRow[accessor])
                dataRow[accessor] = formattedDate
            });
            currencyCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? ReactComponentHelper.formatToCurrency(dataRow[accessor]) : dataRow[accessor];
            });
            return dataRow;
        });
        let fileName = (this.state.selection && this.state.selection.reportType) ? this.state.selection.reportType.replace(' ', '') + '.csv' : "DataMining.csv"

        const NoDataComponent = props => (
            <NoData
                noDataText="transactionReports_NoData"
                {...props}
            />
        )

        return (
            <div data-test="component-intrastat-lines-page">
                <ReactTable
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    minRows={0}
                    maxRows={0}
                    ref={ref => this.viewTable = ref}
                    data={intrastatLinesData}
                    columns={columns}
                    loading={this.props.loading} // Display the loading overlay when we need it
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={false}
                    showPageJump={true}
                    NoDataComponent={NoDataComponent}
                    className={_.isEmpty(intrastatLinesData) ? 'mb30 hide-header horizontal-scroll-table' : 'mb30 horizontal-scroll-table'}
                    PaginationComponent={Pagination}
                    showPagination={intrastatLinesData.length === 0 ? false : true}
                />
                <CSVLink
                    data={sanitizeCsvData(dateAndCurrencyFormatedIntrastatLinesData)}
                    filename={fileName}
                    className={dateAndCurrencyFormatedIntrastatLinesData && dateAndCurrencyFormatedIntrastatLinesData.length > 0 ? "button secondary" : "invisible"}>
                    <LanguageStringResolver string='viewTransmission_ExportToCSV' />
                </CSVLink>
            </div>
        );
    }
}


IntrastatLinesPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
}

function mapStateToProps(state) {
    return {
        languages: state.languages,
        intrastatLinesData: (state.dataMining && state.dataMining.intrastatLines)
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.doGetIntrastatLinesData = (params, callback) => {

        log.debug('doGetIntrastatLinesData()');
        dispatch(DATA_MINING_CONTROLLER.doGetIntrastatLinesData(params, callback));
    }
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(IntrastatLinesPage);